
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pid]",
      function () {
        return require("private-next-pages/[pid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pid]"])
      });
    }
  